import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6ccd30ac")

_pushScopeId("data-v-6ccd30ac")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "r-grid container" }, [
  /*#__PURE__*/_createVNode("h2", null, "Holidays")
], -1)
const _hoisted_2 = { class: "r-grid grid-container" }
const _hoisted_3 = { class: "date" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GroupContainer = _resolveComponent("GroupContainer")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_GroupContainer, null, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userHolidayData, (item, index) => {
            return (_openBlock(), _createBlock(_Fragment, { key: index }, [
              _createVNode("div", _hoisted_3, _toDisplayString(_ctx.formatDate(item.date)), 1),
              _createVNode("div", null, _toDisplayString(item.title), 1),
              _createVNode("div", null, _toDisplayString(_ctx.parseGroup(item.applies_to)), 1)
            ], 64))
          }), 128))
        ])
      ]),
      _: 1
    })
  ], 64))
})